import goalSettingsStepsSchema from './GoalSettings/stepsSchema';
import dietSettingsStepsSchema from './DietSettings/stepsSchema';
import biometricSettingsStepsSchema from './BiometricSettings/stepsSchema';
import packageJson from '../package.json';
export const ALLOWED_LANGUAGES = ['en-US'];

export const SENTRY_DSN =
  'https://20e961561c1f2020a371d4cec438e98c@o251048.ingest.us.sentry.io/4509389102710784';

export const APP_STORE_URL = 'https://resilient.onelink.me/STwK/o7hiiq1g';
export const GOOGLE_PLAY_URL = 'https://resilient.onelink.me/STwK/o7hiiq1g';

export const APP_VERSION = packageJson.version;
export const APP_BRAND = 'resilient';

export const SLIDE_ROUTES_DURATION = 350;

export const LANDING_URL = 'https://resilient.com/';

export const siteMetadata = {
  lang: 'en',
  shortName: 'resilient',
  name: 'resilient',
  themeColor: '#ffffff',
  title: 'Resilient',
  description: '',
  keywords: ['resilient'],
  author: 'activerse.app',
};

export const INSTACART_FIREBASE_FUNCTION =
  'https://resilientinstacartgenerator-tsrjlkvj4a-uc.a.run.app';
export const INSTACART_URL = 'https://www.instacart.com/store/partner_recipes';

export const FRISCO = false;

export const FIRST_DIET_SETTINGS_STEP_SLUG = dietSettingsStepsSchema[0].slug;
export const FIRST_GOAL_SETTINGS_STEP_SLUG = goalSettingsStepsSchema[0].slug;
export const FIRST_BIOMETRIC_SETTINGS_STEP_SLUG = biometricSettingsStepsSchema[0].slug;

export const FORCE_BUILD = false;
